import { render, staticRenderFns } from "./InputArea.vue?vue&type=template&id=1f424f1d&scoped=true&"
import script from "./InputArea.vue?vue&type=script&lang=js&"
export * from "./InputArea.vue?vue&type=script&lang=js&"
import style0 from "./InputArea.vue?vue&type=style&index=0&id=1f424f1d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f424f1d",
  null
  
)

export default component.exports